export default "__VITE_ASSET__DwyVKgxa__"